import React from "react";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import AssetCard from "./AssetCard";
import { useCustomFields } from "../../../contexts/customFields";

const styles = {
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 420 },
    maxHeight: "90vh",
    overflow: "auto",
  },
  paper: {
    position: "relative",
    padding: 0,
    margin: 0,
  },
  closeButton: {
    position: "absolute",
    right: -4,
    top: -4,
    zIndex: 1,
  },
};

export default function CreateKitVariantModal({ open, asset, onClose, defaultValues }) {
  const [display] = useCustomFields();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.modalBox}>
        <Paper sx={styles.paper}>
          <IconButton onClick={onClose} sx={styles.closeButton}>
            <CloseIcon />
          </IconButton>
          <AssetCard
            asset={asset}
            display={display}
            defaultValues={defaultValues}
            onClickImage={() => {}}
            onSuccess={onClose}
            editableKitDetails={true}
          />
        </Paper>
      </Box>
    </Modal>
  );
}
